import { ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { PageHeaderStyled } from 'pages/automations/common/Common.styles';

interface ScheduledMessagesTabHeaderProps {
  children: ReactNode;
}

const ScheduledMessagesTabHeader = ({
  children,
}: ScheduledMessagesTabHeaderProps) => {
  const { t } = useTranslation();

  return (
    <PageHeaderStyled
      title={t('pageAutomations.scheduledMessages.title')}
      subtitle={
        <Trans
          i18nKey="pageAutomations.scheduledMessages.subtitle"
          components={{
            link1: (
              <a
                aria-label="Hostfully documentation"
                href="https://help.hostfully.com/en/articles/3689112-monitor-templates-and-triggers"
                target="_blank"
                rel="noreferrer"
              />
            ),
          }}
        />
      }
      noDivider
    >
      <div className="child-container">{children}</div>
    </PageHeaderStyled>
  );
};

export default ScheduledMessagesTabHeader;
